import { Header, PageTitle, withLayout } from '../../components';
import { NextPage } from 'next';
import { Link } from '@/components/link/Link';

const Page: NextPage = () => {
  return withLayout(
    <>
      <Header />
      <section>
        <PageTitle title="退会しました" />
        <div className="mx-auto flex w-full flex-col items-center p-5 sm:max-w-md">
          <p className="mt-4 text-center text-[14px] font-normal">
            退会手続きが完了しました。
            <br />
            もう一度ご利用になりたい場合は、
            <br />
            再度ログインをお願いします。
          </p>
          <p className="mt-4 text-center text-[14px] font-normal">
            *一部占い師の提供する
            <br />
            サブスクリプションプランは
            <br />
            RAYSEEの退会に伴って
            <br />
            自動で<strong>解約されません</strong>。<br />
            各サブスクリプションプランの
            <br />
            解約方法はプランを提供する
            <br />
            占い師の公式LINEにて
            <br />
            お問い合わせください。
          </p>
          <Link
            href="/"
            className="relative mt-10 flex h-[50px] w-[230px] items-center justify-center rounded-md border border-[#8C848A] bg-[#F2F2F2]"
          >
            <p className="inset-0 text-center text-[#8C848A]">トップページへ</p>
          </Link>
        </div>
      </section>
    </>,
  );
};

export default Page;
